import { DEFAULT_LOCALE } from '@/configuration/lang/lang';
import { getLocale } from '@/configuration/lang/langSlice';
import { RootState } from '@/configuration/setup/store';
import { getAccessToken } from './tokenSlice';

export const prepareHeaders = (headers: Headers, { getState }: { getState: () => unknown }) => {
    const state = getState() as RootState;
    const token = getAccessToken(state);
    const locale = getLocale(state);

    if (token) {
        headers.set('Authorization', `Bearer ${token}`);
    }

    headers.set('Accept-Language', locale ?? DEFAULT_LOCALE);
    return headers;
};
